import styled from 'styled-components'

export const Container = styled.div`
    /* padding: 20px; */

    .pagination {
        display: flex;
        justify-content: center;
    }
`

export const Filter = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    @media (min-width: 720px) {
        gap: 30px;
    }
    .top-bar {
        display: flex;
        flex-direction: column;
        gap: 14px;

        h1 {
            /* font-size: 20px; */
            color: #333;
            /* font-family: 'Inter';
            font-weight: 500; */

            font-family: 'Poppins';
            font-size: 22px;
            font-weight: 400;
        }

        .right-side {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }

        @media (min-width: 720px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0px;

            .right-side {
                flex-direction: row;
                align-items: center;
                justify-content: initial;
            }
        }
    }

    .bottom-bar {
        display: flex;
        flex-direction: column-reverse;
        gap: 14px;

        .select {
            display: flex;
            gap: 10px;
        }

        .right-side {
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
        }

        @media (min-width: 720px) {
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 0px;

            .right-side {
                justify-content: initial;
                .react-datepicker-wrapper {
                    width: auto;
                }
            }
        }
    }
`

export const SolicitacaoContainer = styled.div`
    margin-top: 30px;
    border-radius: 10px;
    background: #fff;
    box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
        rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
    margin-bottom: 40px;
    overflow: auto;
`
export const Header = styled.header`
    padding: 15px 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-width: 1000px;
    position: relative;

    .left {
        display: flex;
        align-items: center;
        gap: 14px;
    }

    .title {
        h2 {
            font-family: 'Roboto';
            font-weight: 500;
            font-size: 20px;
        }
    }
`
export const Table = styled.table`
    padding: 10px;
    table-layout: fixed;
    border-collapse: collapse;
    width: 100%;
    min-width: 1000px;

    /* &.my-links {
    min-width: 1280px;
  } */
    thead {
        padding: 0 10px;
        border-bottom: 1px solid #d3d3d3;
        border-top: 1px solid #d3d3d3;

        th {
            color: #a8a39d;
            font-weight: 400;
            font-family: 'Poppins';
            font-size: 14px;
            padding: 10px 0;
            height: 63px;
            /* width: min-content; */
        }

        th:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        /* 
    th.valor {
      width: 10%;
    } */

        th:last-child {
            width: 50px;
        }
    }

    tbody {
        tr:not(tr:last-child) {
            border-bottom: 1px solid #d3d3d3;
        }

        tr > td {
            color: #333;
            font-family: 'Inter';
            font-weight: 400;
            font-size: 12px;
            /* width: max-content; */
        }

        td:first-child {
            /* width: 50px; */
            padding: 0 10px;
        }
        tr {
            cursor: pointer;

            &:hover {
                background: rgba(0, 157, 221, 0.1);
            }
        }

        .actions {
            display: flex;
            align-items: center;
            gap: 8px;

            form {
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .link {
            display: flex;
            align-items: center;
            gap: 6px;
            color: #4c83ee;
        }
    }

    td,
    th {
        padding: 15px 0;
        text-align: left;
    }

    .order {
        display: inline-flex;
        align-items: center;
        gap: 3px;
        transform: rotate(0deg);
        transition: transform 0.2s ease-in;
        cursor: pointer;
    }

    .order.desc {
        svg {
            transform: rotate(180deg);
        }
    }
`
export const Option = styled.span``
